import React, { useMemo } from 'react'
import { Box, Card, CardContent, Divider, Link, Typography } from '@mui/material'
import { SETTINGS_COLLECTION } from '../../_constants/globals'
import { useFirestore } from '../../hooks/useFirestore'
import InlineEditor from '../_library/InlineEditor'


const GCP_CLIENT_LINK = 'https://console.cloud.google.com/auth/clients'
const GCP_OAUTH_PLAYGROUND_LINK = 'https://developers.google.com/oauthplayground'
export const ApisOverviewPanel = () => {
  
  const settingHooks = useFirestore(SETTINGS_COLLECTION)
  const dbSettings = settingHooks.getDocs()
  
  const { calendarId, oauthClientId, oauthClientSecret, oauthRefreshToken } = useMemo(() => dbSettings[0], [dbSettings])
  
  return (
    <Box sx={{ my: 3, mx: 'auto', maxWidth: 900 }}>
      <Typography variant='body2' color='textSecondary' gutterBottom mb={1}>Google Calendar API (OAuth)</Typography>
      <Card variant='outlined' sx={{ minWidth: '275px', mb: 3 }}>
        <CardContent>
          <Typography mb={2}>Bookings are synchronised over Google Calendar API with the calendar below</Typography>
          <InlineEditor title='Calendar Id' value={calendarId} handleSubmit={val => settingHooks.setDoc('default', { calendarId: val })} />
          <Divider sx={{ my: 2 }} />
          <Typography>The API needs all the following credentials to log in with oauth protocol.</Typography>
          <Typography>Create OAuth client here: <Link href={GCP_CLIENT_LINK}>{GCP_CLIENT_LINK}</Link></Typography>
          <Typography mb={2}>Use <Link href={GCP_OAUTH_PLAYGROUND_LINK}>{GCP_OAUTH_PLAYGROUND_LINK}</Link> to generate refresh token</Typography>
          <InlineEditor title='Client Id' value={oauthClientId} handleSubmit={val => settingHooks.setDoc('default', { oauthClientId: val })} />
          <InlineEditor title='Client secret' value={oauthClientSecret} handleSubmit={val => settingHooks.setDoc('default', { oauthClientSecret: val })} />
          <InlineEditor title='Refresh token' value={oauthRefreshToken} handleSubmit={val => settingHooks.setDoc('default', { oauthRefreshToken: val })} />
        </CardContent>
      </Card>
    </Box>
  )
}

export default ApisOverviewPanel
